import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Raffle } from 'src/app/data/schema/raffle';
import { RaffleCartService } from 'src/app/data/service/raffle-cart.service';

@Injectable()
export class RaffleGuard implements CanActivate {
  constructor(private router: Router, private cartService: RaffleCartService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {

    // this guard makes sure that a user has a raffle when accessing pages, and if they don't,
    // will use the raffle code from route to load the raffle
    const code = next.paramMap.get('code');

    if (Raffle.currentRaffle != null && Raffle.currentRaffle.accessCode === code) {

      if (state.url.includes('payment') && this.cartService.userDetails == null) {
        console.error('Payment page loaded, but no cart details so going back to raffle home: ' + state.url);
        this.router.navigateByUrl('/' + Raffle.currentRaffle.accessCode);
        return false;
      }

      return true;
    }

    // no code provided, so no raffle, take user back to home page
    if (code == null) {
      console.error('No code provided, go to hom, trying to go to: ' + state.url);
      this.router.navigateByUrl('/');
      return false;
    }

    // console.log('Attempting to load raffle with code', code);

    return Raffle.getByCode(code).then(() => {
      // console.log('Attempt to load raffle with code result', this.raffleService.currentRaffle);
      if (Raffle.currentRaffle != null) {
        if (state.url.includes('payment') && this.cartService.userDetails == null) {

          console.error('Raffle found, but trying to go to payment page with no cart: ' + state.url);
          this.router.navigateByUrl('/' + Raffle.currentRaffle.accessCode);
          return false;
        }
        return true;
      }
      console.error('Raffle not found trying to go to: ' + state.url);
      this.router.navigateByUrl('/');
      return false;
    }).catch(error => {
      console.error('Attempt to load raffle with code error', error);
      this.router.navigateByUrl('/');
      return false;
    });
  }
}
